import { Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import ReactDOM from "react-dom"
import { connect } from "react-redux"
import styled from "styled-components"

import { updateChoice } from "areas/product/store/actions"
import { Box, Flex, Typography } from "components/common"

const DiamondSideSelect = styled(Box).attrs({
  as: "select",
})`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
    border-radius: 0;
    display: block;
    margin-top: 10px;
    width: 100%;
    &:focus {
      outline: none;
    }
  `}
`
/**
 * Diamond initials
 * example product - JLUX56-P2
 *
 * @param {object} data - from choice-options.jsx
 * @param {object} selectedValue - from choice-options.jsx
 */
const InternalInitialOptions = ({
  data,
  images,
  options,
  selectedValues,
  setChoice,
}) => {
  return (
    <Flex gutter="10px" mb="16px">
      {Object.keys(options).map((pref, i) => {
        const imgSrc = images[`${pref}_view`]
          ? images[`${pref}_view`].src
          : null
        return (
          <Box key={`initials-${pref}`} textAlign="center">
            <Typography mb="5px">
              {data.options_display_labels[pref]}
            </Typography>
            <Image
              height="100px"
              mb="5px"
              src={
                imgSrc || require("images/product/diamond/diamond_setting.png")
              }
              width="100px"
            />
            <DiamondSideSelect
              data-cy={`product-wizard-options-signature-${pref}-${selectedValues[pref]}`}
              onChange={(e) => setChoice(pref, e)}
              value={selectedValues[pref] || options[pref][0].value}
            >
              <option value="">Select</option>
              {options[pref].map((initial, index) => (
                <option
                  key={`DiamondSide-${initial.value}`}
                  value={initial.value}
                >
                  {initial.value}
                </option>
              ))}
            </DiamondSideSelect>
          </Box>
        )
      })}
    </Flex>
  )
}

InternalInitialOptions.propTypes = {
  setChoice: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const data = ownProps.data

  return {
    images: {
      ...state.wizard.images,
      ...state.previewImage.data.images,
    },
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChoice: (pref, e) => {
      const val = e.target.value
      const cv = ownProps.data.options.find(
        (cv) => cv.value == val && cv.pref == pref
      )
      dispatch(updateChoice(pref, cv, true))
    },
  }
}

const InitialOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalInitialOptions)

export default InitialOptions
